import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiFunction, URL } from "./utils";

const pendingUsersApi = createApi({
  reducerPath: "pendingUsers",
  baseQuery: fetchBaseQuery({
    baseUrl: `${URL.url}`,
    fetchFn: async (...args) => {
      // REMOVE FOR PRODUCTION
      return fetch(...args);
    },
  }),
  tagTypes: "PendingUsers",
  endpoints(builder) {
    return {
      getPendingUsers: builder.query({
        query: (data) => {
          return apiFunction(data, "/api/pending-users/list", "POST");
        },
        providesTags: ["PendingUsers"],
      }),
      approvePendingUser: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/pending-users/approve", "POST");
        },
        invalidatesTags: ["PendingUsers"],
      }),
      rejectPendingUser: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/pending-users/reject", "POST");
        },
        invalidatesTags: ["PendingUsers"],
      }),
      deletePendingUser: builder.mutation({
        query: (data) => {
          return apiFunction(data, "/api/pending-users/delete", "POST");
        },
        invalidatesTags: ["PendingUsers"],
      }),
      permanentDeletePendingUser: builder.mutation({
        query: (data) => {
          return apiFunction(
            data,
            "/api/pending-users/permanent-delete",
            "POST"
          );
        },
        invalidatesTags: ["PendingUsers"],
      }),
    };
  },
});

export const {
  useLazyGetPendingUsersQuery,
  useApprovePendingUserMutation,
  useRejectPendingUserMutation,
  useDeletePendingUserMutation,
  usePermanentDeletePendingUserMutation,
} = pendingUsersApi;
export { pendingUsersApi };
